module.exports = __webpack_public_path__ + "static/media/logo-CCDB.26215aeb.png";